module.exports = __webpack_public_path__ + "assets/clinic.58e26f93.png";